import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Checkbox } from "@common/checkbox";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { ToggleArrow } from "./toggleArrow";
import { Props } from "./types";
import styles from "./styles.scss";

function FilterOptions({ filter, onFilterChange }: Props) {
  const { t } = useTranslation();

  const getSelectedFilters = () => {
    const selected = [];
    if (filter.includeDeactivated) {
      selected.push(t("timeSheet.deactivatedResourcesToggle"));
    }
    if (filter.includeRemovedFromProject) {
      selected.push(t("timeSheet.removedResourcesToggle"));
    }
    if (filter.includeCompletedTasks) {
      selected.push(t("timeSheet.workDoneToggle"));
    }

    return selected.length > 0
      ? selected.join(", ")
      : t("timeSheet.filters.default");
  };

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div
          className={classNames(styles.optionsFilter, {
            [styles.opened]: isVisible,
          })}
        >
          <div className={styles.input} onClick={isVisible ? hide : show}>
            <p className={styles.selectedOptions}>{getSelectedFilters()}</p>
            <ToggleArrow className={styles.toggleArrow} />
          </div>

          {isVisible && (
            <div className={styles.list}>
              <div
                className={styles.item}
                onClick={() =>
                  onFilterChange({
                    ...filter,
                    includeDeactivated: !filter.includeDeactivated,
                  })
                }
              >
                <Checkbox isChecked={filter.includeDeactivated} />
                <p className={styles.typeName}>
                  {t("timeSheet.deactivatedResourcesToggle")}
                </p>
              </div>
              <div
                className={styles.item}
                onClick={() =>
                  onFilterChange({
                    ...filter,
                    includeRemovedFromProject:
                      !filter.includeRemovedFromProject,
                  })
                }
              >
                <Checkbox isChecked={filter.includeRemovedFromProject} />
                <p className={styles.typeName}>
                  {t("timeSheet.removedResourcesToggle")}
                </p>
              </div>
              <div
                className={styles.item}
                onClick={() =>
                  onFilterChange({
                    ...filter,
                    includeCompletedTasks: !filter.includeCompletedTasks,
                  })
                }
              >
                <Checkbox isChecked={filter.includeCompletedTasks} />
                <p className={styles.typeName}>
                  {t("timeSheet.workDoneToggle")}
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { FilterOptions };
